// View Item Codes report (legacy Reports/ViewItemCodes.cshtml) — pure helpers.

export const SELECT_ALL = 'Select All';

// spGetViewItemCategoryDetails: CategoryValue = "<code>  ,<name>", plus one
// "Select All" row. spGetMajorgroupCodes needs the plain name (legacy: split(',')[1]).
export const categoryNameOf = (categoryValue) => {
    const s = String(categoryValue || '');
    const i = s.indexOf(',');
    return i < 0 ? '' : s.slice(i + 1).trim();
};

export const isSelectAllCategory = (categoryId) => categoryId === SELECT_ALL;

// Legacy rules: category required; for a real category the major group is also
// required ("Select All" counts as a choice). Returns an error message or ''.
export const validateItemCodeFilters = ({ category, majorGroup }) => {
    if (!category) return 'Select Item Category Code';
    if (!isSelectAllCategory(category) && !majorGroup) return 'Select Major Group';
    return '';
};

// Category "Select All" → GetItemcodedetails (all approved items);
// otherwise → ViewItemCodesGridDetail(ICC, MGC), MGC may be "Select All".
export const buildItemCodeRequest = ({ category, majorGroup }) =>
    isSelectAllCategory(category)
        ? { mode: 'all' }
        : { mode: 'detail', icc: category, mgc: majorGroup };

// Client-side search over the visible columns (legacy DataTable search box).
export const filterItemCodes = (rows, search) => {
    const list = Array.isArray(rows) ? rows : [];
    const q = String(search || '').trim().toLowerCase();
    if (!q) return list;
    return list.filter(r =>
        [r.ItemCode, r.Itemname, r.Specification, r.Units, r.ItemcodeDca, r.Basicprice]
            .some(v => v != null && String(v).toLowerCase().includes(q)));
};

// Same columns and order as legacy ExportExcelIC.
export const toExcelRows = (rows) => (Array.isArray(rows) ? rows : []).map(r => ({
    'Item Code':     r.ItemCode ?? '',
    'Item Name':     r.Itemname ?? '',
    'Specification': r.Specification ?? '',
    'Units':         r.Units ?? '',
    'DCA':           r.ItemcodeDca ?? '',
    'Basic Price':   Number(r.Basicprice) || 0,
}));
